import * as React from 'react'
const TrashIcon = ({ ...props }) => {
  return (
    <svg width="14" height="16" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.79531 9.66119L1.26056 2.70774H8.85264L8.22665 9.68155C8.15261 10.5065 7.46128 11.1385 6.63306 11.1385H3.3906C2.55453 11.1385 1.85942 10.4948 1.79531 9.66119Z"
        stroke="black"
        strokeWidth="0.8"
      />
      <rect x="0.4" y="1.16929" width="9.2" height="1.50769" rx="0.6" stroke="black" strokeWidth="0.8" />
      <rect x="4.23081" y="0.384615" width="1.53846" height="0.769231" stroke="black" strokeWidth="0.769231" />
      <line x1="4.24619" y1="4.61536" x2="4.24619" y2="9.23074" stroke="black" strokeWidth="0.8" />
      <line x1="5.78452" y1="4.61536" x2="5.78452" y2="9.23074" stroke="black" strokeWidth="0.8" />
    </svg>
  )
}

export default TrashIcon
